import React, {useEffect, useState} from 'react'; 

//MUI helpers
import { makeStyles } from '@material-ui/core/styles';
//MUI components
import { 
    Paper, 
    Table, 
    TableHead, 
    TableRow, 
    TableBody,  
    TableCell,
    IconButton,
    Typography,
    Box,
    Button
} from '@material-ui/core';
//MUI icons
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
//custom components
import Loader from './../../components/Loader';
//REDUX
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchActionFields } from "../../redux/actions/connectionActions"; 

//shared styles
import { Dashboard as DashboardLayout } from "layouts";

// Component styles
import styles from "./styles";

//for date formating
const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const useStyles = makeStyles(styles);

function ActionButtonList(props){
    const classes = useStyles();

    const handleEditClick = (id) => {
      props.history.push("/action-buttons/" + id);
    };

    const handleNewClick = () => {
      props.history.push("/action-button-create");
    }

    useEffect(()=>{
      if(props.tenant === undefined)return;
      props.fetchActionFields(props.tenant); 
    },[props.tenant]);

    function formatDate(date) {
      var d = new Date(parseInt(date)),
          month = '' + (monthNames[d.getMonth()]),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
  
      return [day, month, year].join(' ');
  }


    return  <DashboardLayout title="Action Buttons">
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h3" component="h3">Action Buttons</Typography>
                <Button onClick={() => handleNewClick() } color="primary" variant="contained"><AddIcon /> Create New</Button>
              </Box>
              <br /><br />
                <Paper>
                    <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>NAME</TableCell>
                            <TableCell>LAST UPDATED</TableCell>
                            <TableCell>LAST USER UPDATED</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                         {props.actionFields?.fields?props.actionFields.fields.map((item, index) => {
                          return(
                            <TableBody key={item.title}> 
                                <TableRow>
                                    <TableCell><span className={classes.buttonPreview}>{item.title}</span></TableCell>
                                    <TableCell>{item.lastUpdated?formatDate(item.lastUpdated):""}</TableCell>
                                    <TableCell>{item.tenant}</TableCell>
                                    <TableCell><IconButton color="primary" onClick={() => handleEditClick(index)}><EditIcon /></IconButton></TableCell>
                                </TableRow>
                            </TableBody>
                          )
                         }):props.actionFields?<p>No Results</p>:
                         <Loader />}

                    </Table>
                </Paper>
            </DashboardLayout>
}

function mapStateToProps(state) {
    return {
      actionFields: state.connections.fields,
      tenant: state.skill.tenant,
      status: state.connections.status
    }
  }
  
  function mapDispatchToProps(dispatch) {
    return{
      ...bindActionCreators({
        fetchActionFields
      }, dispatch),
      dispatch
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionButtonList);